import clsx from 'clsx'
import {FC, useState, useRef, useEffect} from 'react'
import {useAuth} from '../../../../app/modules/auth'
import {toAbsoluteUrl} from '../../../helpers'
import {fileSrc} from '../../../../_component/fileUtils'
import {Link} from 'react-router-dom'

const Topbar: FC = () => {
  const {currentUser} = useAuth()
  const [menuOpen, setMenuOpen] = useState(false)
  const toggleRef = useRef<HTMLDivElement>(null)

  // close on outside click
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (toggleRef.current && !toggleRef.current.contains(event.target as Node)) {
        setMenuOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className='flex items-center flex-shrink-0'>
      <div ref={toggleRef} className='flex items-center ml-2 lg:ml-3 cursor-pointer relative'>
        <button
          onClick={() => setMenuOpen((prev) => !prev)}
          className={clsx(
            'flex items-center space-x-2 focus:outline-none rounded-full overflow-hidden',
            'w-[30px] h-[30px] md:w-[40px] md:h-[40px]'
          )}
        >
          <img
            className='rounded-full w-[30px] h-[30px] md:w-[40px] md:h-[40px] object-cover'
            src={
              currentUser?.image
                ? fileSrc(currentUser.image)
                : toAbsoluteUrl('/media/avatars/blank.png')
            }
            alt={currentUser?.first_name}
          />
          <span className='hidden md:inline text-sm font-medium text-gray-800 whitespace-nowrap'>
            {currentUser?.last_name} {currentUser?.first_name}
          </span>
        </button>

        {/* Conditionally show dropdown */}
        {menuOpen && (
          <div className='absolute right-0 top-full mt-2 z-50'>
            <HeaderUserMenu />
          </div>
        )}
      </div>
    </div>
  )
}

export {Topbar}

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  return (
    <div
      className='menu bg-white dark:bg-gray-800 rounded-md shadow-md flex flex-col font-semibold text-sm w-[275px] py-4'
      data-kt-menu='true'
    >
      <div className='px-3'>
        <div className='flex items-center px-3'>
          <div className='w-[50px] h-[50px] rounded-full overflow-hidden mr-5'>
            {/* <img
              src={
                currentUser?.image
                  ? fileSrc(currentUser.image)
                  : toAbsoluteUrl('/media/avatars/blank.png')
              }
              alt={currentUser?.first_name}
              className='w-full h-full object-cover'
            /> */}
          </div>

          <div className='flex flex-col overflow-hidden'>
            <div className='font-bold flex items-center text-base text-gray-900 dark:text-white'>
              {currentUser?.first_name} {currentUser?.last_name}
            </div>
            <span className='text-gray-500 dark:text-gray-400 hover:text-primary text-xs truncate'>
              {currentUser?.email}
            </span>
            <span className='text-gray-500 dark:text-gray-400 hover:text-primary text-xs truncate'>
              {/* {currentUser?.accounts?.[0]?.role?.name} */}
            </span>
          </div>
        </div>
      </div>

      <div className='border-t my-2 border-gray-200 dark:border-gray-700'></div>

      <div className='px-5'>
        <Link
          to={'/profile'}
          className='block px-5 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition'
        >
          My Profile
        </Link>
      </div>

      <div className='border-t my-2 border-gray-200 dark:border-gray-700'></div>

      <div className='px-5'>
        <button
          onClick={logout}
          className='block px-5 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition'
        >
          Sign Out
        </button>
      </div>
    </div>
  )
}
